const translation = {
  // ===== FinancialModel 國際化 =====
  "FinancialModel.analysisSuffix": " - 財務分析",
  "FinancialModel.costStructure.cost_cloud": "雲服務軟件",
  "FinancialModel.costStructure.cost_labor": "人力成本",
  "FinancialModel.costStructure.cost_marketing": "市場與銷售",
  "FinancialModel.costStructure.cost_misc": "雜項預備金",
  "FinancialModel.costStructure.cost_material": "研發材料設備",
  "FinancialModel.costStructure.cost_admin": "行政與合規",
  "FinancialModel.efficiencyAnalysis.coreStaffAnnualSalary": "核心人員年度薪資",
  "FinancialModel.efficiencyAnalysis.maAnnualSalary": "馬總年薪",
  "FinancialModel.efficiencyAnalysis.liaoAnnualSalary": "廖工年薪",
  "FinancialModel.efficiencyAnalysis.totalAnnualLaborCost": "年度總人工成本",
  Product: "產品",
  "Header.productNav": "LUKKEY 產品",
  Feature: "特色",
  "About Us": "關於我們",
  FAQ: "常見問題",
  "Privacy Policy": "隱私政策",
  "Help Center": "幫助中心",
  "Header.infoMenu": "更多",
  "Header.appNow": "取得 App",
  "Header.appModal.title": "立即使用 LUKKEY App",
  "Header.appModal.subtitle": "選擇你的平台，取得官方 LUKKEY 行動應用程式。",
  "Header.appModal.iosTitle": "iOS App Store",
  "Header.appModal.iosDesc": "在 iPhone 上安裝官方應用程式。",
  "Header.appModal.iosButton": "打開",
  "Header.appModal.googlePlayTitle": "Google Play",
  "Header.appModal.googlePlayDesc": "前往 Google Play 取得官方 Android 應用程式。",
  "Header.appModal.googlePlayButton": "打開",
  "Header.appModal.androidTitle": "Android APK",
  "Header.appModal.androidDesc": "直接下載最新版官方 APK。",
  "Header.appModal.androidButton": "下載",
  "Header.appModal.note": "僅提供官方行動端下載，請使用以上連結取得最新版本。",
  "Academy": "學院",
  "Legal": "法律",
  "AboutUs.title": "關於 LUKKEY",
  "AboutUs.lede": "LUKKEY 是一家瑞士硬體錢包品牌，致力於打造數位資產所有權的最高安全標準。",
  "AboutUs.vision.closing": "你的私鑰。你的資產。你的未來。",
  "AboutUs.quote": "LUKKEY 在人與數位資產之間建立一道安全邊界。",
  "AboutUs.block1": "LUKKEY 總部位於瑞士，專注於面向安全自我託管的硬體錢包產品。",
  "AboutUs.block2": "其產品結合安全元件、防竄改保護與全離線架構，目標是讓私鑰始終保留在隔離環境中。",
  "AboutUs.block3": "系統不依賴 Wi‑Fi、USB 或直接連網。指紋解鎖、NFC 備份工具與廣泛的資產支援，讓產品在日常使用中保持實用。",
  "AboutUs.block5": "LUKKEY 對核心韌體與軟體採用開放且可稽核的方式。安全能力應可被檢查，也可被驗證。",
  "HelpCenter.back": "返回幫助中心",
  "WarrantySupport.title": "支援請求",
  "WarrantySupport.intro": "請填寫以下資訊以提交支援請求。",
  "WarrantySupport.form.name.label": "姓名",
  "WarrantySupport.form.name.placeholder": "請輸入姓名",
  "WarrantySupport.form.email.label": "電子郵件",
  "WarrantySupport.form.email.placeholder": "請輸入電子郵件",
  "WarrantySupport.form.issueTitle.label": "問題概要",
  "WarrantySupport.form.issueTitle.placeholder": "請輸入簡要概要",
  "WarrantySupport.form.warrantyType.label": "請求類型",
  "WarrantySupport.form.warrantyType.placeholder": "請選擇請求類型",
  "WarrantySupport.form.warrantyType.product": "裝置問題",
  "WarrantySupport.form.warrantyType.service": "App/帳戶問題",
  "WarrantySupport.form.warrantyType.replacement": "其他",
  "WarrantySupport.form.feedback.label": "問題描述",
  "WarrantySupport.form.feedback.placeholder": "請詳細描述問題或需求",
  "WarrantySupport.form.submit": "提交支援請求",
  "WarrantySupport.alert.success": "您的支援請求已提交！",
  "WarrantySupport.alert.error": "提交失敗，請稍後再試。",
  "HelpCenter.title": "幫助中心",
  "HelpCenter.intro":
    "歡迎來到 LUKKEY 官方幫助中心與文件支援。這裡提供硬體錢包產品指南、設定說明與疑難排解資料。",
  "HelpCenter.section4.title": "需要更多協助？",
  "HelpCenter.section4.intro":
    "線上提交支援請求可節省時間，我們將安排專人協助。為保護安全，官方支援絕不會索要助記詞或私鑰：",
  "HelpCenter.contact.hint": "可透過下方按鈕提交支援請求，我們將透過電子郵件與您聯絡。",
  "HelpCenter.cta.warranty": "提交支援請求",
  "Footer.contact.email": "電子郵件：info@lukkey.com",
  "Footer.contact.address":
    "Lukkey AG 全球總部，瑞士 Zug，Dammstrasse 16，郵遞區號 6300",
  brandName: "LUKKEY",
  tagline: "以前所未有的方式管理您的加密貨幣",
  description:
    "通過我們的應用程式開始您的財務自由之旅。利用我們先進的冷錢包技術保護您的資產，更智能、更有效地管理您的財務。您的財務健康是我們的首要任務。",
  "home.seoTitle": "LUKKEY | 瑞士硬體冷錢包與安全自我託管",
  "home.seoDescription": "LUKKEY 是專注於冷錢包安全的瑞士硬體錢包品牌，提供離線私鑰保護、指紋存取與 NFC 備份，幫助使用者更安全地實現自我託管。",
  learnMore: "了解更多",
  "Lock Your Crypto, Securely": "安全鎖定您的加密貨幣",
  Testimonials: "使用者評價",
  Testimonial1:
    "我已經使用這個冷錢包好幾個月了，我對它的可靠性和安全功能印象深刻。強烈推薦！",
  Testimonial2:
    "這個冷錢包超出了我的預期！它的用戶友好介面和頂級安全性讓它成為任何認真對待加密貨幣的人必備的工具。",
  Testimonial3:
    "我以前嘗試過幾個冷錢包，但這個脫穎而出。它的流線型設計和先進功能讓管理我的加密資產變得輕而易舉。",
  "John Doe": "約翰·多伊",
  "Cryptocurrency Enthusiast": "加密貨幣愛好者",
  "Jane Smith": "簡·史密斯",
  "Crypto Security Advocate": "加密安全倡導者",
  "Alex Johnson": "亞歷克斯·約翰遜",
  "Investment Analyst": "投資分析師",
  "Touchscreen Interface": "觸控螢幕介面",
  "Experience effortless crypto management with our intuitive touchscreen interface, designed for quick and easy navigation through your digital assets, enabling swift transactions and secure management at your fingertips.":
    "透過我們直觀的觸控螢幕介面，輕鬆管理您的加密資產，設計簡潔，讓您快速且輕鬆地瀏覽數位資產，實現迅速交易並安全管理。",
  "Bluetooth Connectivity": "藍牙連接",
  "Wireless syncing with your devices for real-time updates.":
    "與您的裝置無線同步，實時更新。",
  "Airtag Tracking": "Airtag 跟蹤",
  "Track your wallet easily with built-in Airtag.":
    "輕鬆透過內建的 Airtag 追蹤您的錢包。",
  "Secure Chip Technology": "安全晶片技術",
  "Equipped with an advanced security chip, ensuring robust protection for your valuable digital assets against unauthorized access and cyber threats.":
    "配備先進的安全晶片，確保您的珍貴數位資產免受未經授權的訪問和網絡威脅，提供強大保護。",
  "Cross-Platform Support": "跨平台支援",
  "Works with various platforms for easy accessibility.":
    "與多個平台兼容，方便訪問。",
  AboutUsDescription1:
    "在LUKKEY，我们致力于提供高品质的解决方案，安全地管理您的加密资产。",
  AboutUsDescription2:
    "我们的总部位于瑞士楚格。凭借一支经验丰富的团队，我们努力创新并适应数字货币市场不断变化的格局。",
  BlockchainNetworksSupported: "支持的区块链网络",
  CryptocurrenciesSupported: "支持超过6,000种加密货币",
  Years: "年",
  ExpertiseInSecurity: "在安全领域的专业经验",
  FrequentlyAskedQuestions: "常見問題",
  WhatIsColdWallet: "什麼是冷錢包？",
  ColdWalletDescription:
    "冷錢包是一種加密貨幣錢包，它將您的數位資產離線存儲，從而使其不容易受到駭客攻擊和其他線上威脅。與熱錢包不同，熱錢包是連接到網絡並適合頻繁交易的，而冷錢包則更適合長期儲存，因為它們提供了更強的安全性。",
  HowToSetUpColdWallet: "如何設置冷錢包？",
  ColdWalletSetupDescription:
    "設置冷錢包通常涉及在安全的離線設備上初始化設備。您需要生成並安全地儲存恢復短語，這對於在設備丟失或故障時訪問您的資產至關重要。購買時會提供詳細的說明，確保順利完成設置過程。",
  CryptocurrenciesCompatibleWithColdWallet: "哪些加密貨幣可以與冷錢包兼容？",
  CryptocurrenciesCompatibilityDescription:
    "我們的冷錢包支持多種加密貨幣，包括比特幣、以太坊、萊特幣等主要貨幣，以及各種其他山寨幣。詳情請訪問我們的網站或參閱產品文檔。",
  HowToSecureColdWallet: "如何確保冷錢包安全？",
  ColdWalletSecurityDescription:
    "為了確保冷錢包的安全，始終將恢復短語保存在安全且私密的地方，切勿與任何人分享，並考慮使用額外的安全措施，例如生物識別鎖或安全外殼。定期從官方網站更新錢包的固件也有助於防止漏洞。",
  ColdWalletNotWorking: "如果冷錢包無法正常工作或遇到錯誤，我該怎麼辦？",
  ColdWalletErrorDescription:
    "如果您的冷錢包出現問題，請參考我們用戶指南中的故障排除部分。對於更具體的問題，請通過我們的網站聯繫支持團隊。確保提供設備信息以加快支持過程。",
  Community: "社群",

  "Join our community on your favorite platform to stay up-to-date, ask questions, and connect with other users.":
    "加入我們的社群，在您喜愛的平台上保持最新狀態，提出問題，並與其他用戶建立聯繫。",
  "Subscribe.title": "取得產品更新",
  "Subscribe.subtitle":
    "加密趨勢由我們為你追蹤。獲取產品更新、市場洞察與專屬福利——第一時間直達你的收件箱。",
  "Subscribe.placeholder": "輸入你的電子郵件",
  "Subscribe.button": "訂閱產品更新",
  "Subscribe.input.aria": "電子郵件地址輸入框",
  "Subscribe.success": "訂閱成功！請前往信箱查收確認郵件。",
  "Subscribe.error": "訂閱失敗，請稍後再試。",
  "Subscribe.invalid": "請輸入有效的電子郵件地址。",
  "Subscribe.privacy":
    "你的電子郵件僅用於接收我們的電子報與更新。你可隨時透過郵件中的連結取消訂閱。",
  "Subscribe.learnMore": "了解我們如何管理你的資料與權利。",
  "Subscribe.popupCompact.title": "保持更新",
  "Subscribe.popupCompact.subtitle": "產品更新與安全洞察。不發送垃圾郵件。",
  "Subscribe.popupCompact.button": "訂閱",
  "Subscribe.popupCompact.privacy": "僅用於電子郵件通知。可隨時退訂。",
  "SubscribeConfirmed.alt.success": "訂閱已確認",
  "SubscribeConfirmed.alt.failed": "訂閱確認失敗",
  "SubscribeConfirmed.title.success": "訂閱已確認",
  "SubscribeConfirmed.title.failed": "訂閱失敗",
  "SubscribeConfirmed.message.success":
    "感謝您確認電子郵件。您的訂閱已啟用。歡迎郵件已發送至您的收件匣。",
  "SubscribeConfirmed.message.failed":
    "確認連結無效或已過期。請返回首頁並重新嘗試訂閱。",
  "SubscribeConfirmed.cta.backHome": "返回首頁",
  "SubscribeConfirmed.note.unsubscribe": "您可隨時透過郵件中的連結取消訂閱。",
  // ===== MarketView i18n =====
  "MarketView.title": "市場儀表板",
  "MarketView.loading": "載入中...",
  "MarketView.tab.youtube": "YouTube",
  "MarketView.tab.x": "X（Twitter）",
  "MarketView.tabError.failed": "此分頁渲染失敗",
  "MarketView.unknownError": "未知錯誤",

  // ===== Common i18n =====
  "Common.refresh": "重新整理",
  "Common.toggleSeriesVisibility": "切換此數列顯示",
  "Common.error": "錯誤",
  "Common.dataUpdateTime": "資料更新時間",
  "Common.loading": "載入中...",
  "Common.noDataSource": "無資料（未提供資料來源）",

  // ===== Common ranges =====
  "Common.to": "至",
  "Common.clear": "清除",
  "Common.range.thisMonth": "本月",
  "Common.range.lastMonth": "上月",
  "Common.range.last2": "近2個月",
  "Common.range.last3": "近3個月",
  "Common.range.last6": "近6個月",
  "Common.range.thisYear": "今年",
  "Common.range.all": "全部",
  "Common.range.custom": "自訂",
  "Common.showFilters": "顯示篩選器",
  "Common.hideFilters": "隱藏篩選器",
  "Common.search": "搜尋",
  "Common.priority": "優先級",
  "Common.owner": "負責人",
  "Common.collaborator": "協作者",
  "Common.updatedAt": "更新",

  // ===== YouTubeTab i18n =====
  "YouTubeTab.downloadTitle": "下載後端 data/youtube_stats.json",
  "YouTubeTab.downloadJson": "下載 youtube_stats.json",
  "YouTubeTab.loading": "正在載入 YouTube 指標...",
  "YouTubeTab.errorHint":
    "若提示未配置 API Key，請在 backend/.env 設定 YOUTUBE_API_KEY 或 GOOGLE_API_KEY 並重啟後端。",
  "YouTubeTab.header.totalViews": "總觀看數（多通道對比，單位：萬）",
  "YouTubeTab.header.totalSubscribers": "總訂閱數（多通道對比，單位：萬）",
  "YouTubeTab.dist.views": "觀看數分佈（萬）",
  "YouTubeTab.dist.subscribers": "訂閱數分佈（萬）",
  "YouTubeTab.card.location": "所屬地：",
  "YouTubeTab.card.registeredAt": "註冊時間：",
  "YouTubeTab.card.currentSubscribers": "目前訂閱數",
  "YouTubeTab.card.currentVideos": "目前影片數",
  "YouTubeTab.card.currentTotalViews": "目前總觀看數",
  "YouTubeTab.card.currentTotalComments": "目前總留言數",
  "YouTubeTab.chart.totalSubscribers": "總訂閱數",
  "YouTubeTab.chart.totalViews": "總觀看數",
  "YouTubeTab.chart.totalComments": "總留言數",
  "YouTubeTab.chart.totalVideos": "總影片數",

  // ===== XTab i18n =====
  "XTab.downloadTitle": "下載後端 data/x_stats.json",
  "XTab.downloadJson": "下載 x_stats.json",
  "XTab.loading": "正在載入 X 指標...",
  "XTab.errorHint":
    "若提示未配置 Token，請在 backend/.env 設定 X_BEARER_TOKEN 或 TWITTER_BEARER_TOKEN 並重啟後端。",
  "XTab.header.totalFollowers": "總粉絲數（多通道對比，單位：萬）",
  "XTab.header.totalEngagement":
    "總互動量（最近5則：按讚＋轉推＋回覆＋引用，單位：萬）",
  "XTab.dist.followers": "粉絲數分佈（萬）",
  "XTab.dist.engagement":
    "互動量分佈（最近5則：按讚＋轉推＋回覆＋引用，單位：萬）",
  "XTab.card.currentFollowers": "目前粉絲數",
  "XTab.card.currentFollowing": "目前關注數",
  "XTab.card.currentTweets": "目前推文數",
  "XTab.card.recentLikes": "最近推文按讚總數",
  "XTab.card.recentRetweets": "最近推文轉推總數",
  "XTab.card.recentReplies": "最近推文回覆總數",
  "XTab.card.recentQuotes": "最近瀏覽數（內容層級，最近5則）",
  "XTab.card.listed": "被加入清單數（頻道層級）",
  "XTab.smallChart.followers": "粉絲數",
  "XTab.smallChart.tweets": "推文數",
  "XTab.smallChart.likes": "最近按讚數",
  "XTab.smallChart.retweets": "最近轉推數",
  "XTab.smallChart.replies": "最近回覆數",
  "XTab.smallChart.quotes": "最近瀏覽數（內容層級）",
  "XTab.smallChart.following": "關注數",
  "XTab.smallChart.listed": "被加入清單數",

  // ===== Analytics i18n =====
  "Analytics.filter.monthLabel": "依建立月份篩選：",
  "Analytics.metric.completionRate": "完成率",
  "Analytics.metric.teamVelocity": "團隊速度",
  "Analytics.metric.blockerRatio": "阻塞比例",
  "Analytics.metric.workloadBalance": "負載均衡",
  "Analytics.charts.statusDistribution": "狀態分佈",
  "Analytics.charts.statusByMonthPercent": "狀態按月（百分比）",
  "Analytics.charts.priorityDistribution": "優先級分佈",
  "Analytics.charts.priorityByMonthPercent": "優先級按月（百分比）",
  "Analytics.charts.functionTypeDistribution": "職能類型分佈",
  "Analytics.charts.functionTypeByMonthPercent": "職能類型按月（百分比）",
  "Analytics.blocker.ownerPie": "阻塞問題 · 責任人分佈（環形圖）",
  "Analytics.blocker.ownerByMonth": "阻塞問題 · 責任人按月（百分比）",
  "Analytics.bug.ownerPie": "缺陷問題 · 責任人分佈（環形圖）",
  "Analytics.bug.ownerByMonth": "缺陷問題 · 責任人按月（百分比）",
  "Analytics.ownerWorkloadDistribution": "團隊工作量分佈",
  "Analytics.mode.priority": "優先級分佈",
  "Analytics.mode.status": "狀態分佈",
  "Analytics.mode.type": "類型分佈",
  "Analytics.blocker.attentionNeeded": "需要立即關注的問題",
  "Analytics.common.status": "狀態",
  "Analytics.common.owner": "責任人",
  "Analytics.insights.sectionTitle": "專案洞察與建議",
  "Analytics.insights.efficiency.title": "效率提升建議",
  "Analytics.insights.efficiency.completionRate":
    "• 目前完成率為 {{rate}}%，建議關注阻塞問題",
  "Analytics.insights.efficiency.avgVelocity":
    "• 團隊平均速度為 {{velocity}} 個任務/人",
  "Analytics.insights.efficiency.workloadBalance":
    "• 工作負載均衡度為 {{balance}}%",
  "Analytics.insights.risk.title": "風險警示",
  "Analytics.insights.risk.blockerRatio": "• 阻塞比例 {{ratio}}%",
  "Analytics.insights.risk.p0Ratio": "• P0 等級問題比例 {{ratio}}%",
  "Analytics.insights.risk.suggestion": "• 建議優先處理高優先級問題",

  // ===== Kanban i18n =====
  "Kanban.title": "看板視圖",
  "Kanban.totalIssues": "共 {{count}} 個問題",
  "Kanban.searchPlaceholder": "搜尋標題、問題編號、負責人或協作者...",
  "Kanban.status.backlog": "待處理",
  "Kanban.status.inProgress": "進行中",
  "Kanban.status.blocked": "阻塞/待確認",
  "Kanban.status.reviewTest": "評審 / 測試",
  "Kanban.status.docs": "Docs",

  // ===== List i18n =====
  "List.title": "議題清單",
  "List.totalIssues": "共 {{count}} 個問題",
  "List.viewDetails": "檢視詳情",
  "List.openInNewWindow": "在新視窗開啟",
  "List.empty.title": "無議題",
  "List.empty.subtitle": "建立第一個議題以開始你的工作流程",

  // ===== Assets Register i18n =====
  "Assets.title": "資產設備登記表",
  "Assets.totalSets": "合計套數",
  "Assets.table.employee": "員工",
  "Assets.table.setCount": "套數",
  "Assets.table.screen": "螢幕",
  "Assets.table.model": "型號",
  "Assets.total": "合計",
  "Assets.production.title": "量產設備登記表",
  "Assets.production.totalUnits": "量產合計台數",
  "Assets.production.table.sn": "設備編號",
  "Assets.production.table.owner": "持有人／去向",
  "Assets.production.table.status": "狀態",
  "Assets.production.table.note": "備註",
  "Assets.production.total": "合計",
  "Assets.people.screenIcVendor": "螢幕IC廠",
  "Assets.people.stVendor": "ST原廠",
  "Assets.models.gen3EalPcb": "3代EAL版pcb",
  "Assets.models.gen3Pcb": "3代pcb",
  "Assets.models.gen3PcbDamagedBluetooth":
    "❌3代pcb已損壞(PCB藍牙無法燒錄)",
  "Assets.models.gen3AssembledBlackUnit": "3代整機組裝版pcb(黑色整機)",
  "Assets.models.gen3PcbDamagedSerial": "❌3代pcb(串口損壞)",
  "Assets.production.models.black": "黑色",
  "Assets.production.models.silver": "銀色",
  "Assets.production.models.champagneGold": "香檳金",
  "Assets.production.models.blackKeystonePrototype": "黑色（keystone樣機）",
  "Assets.production.models.blackHardwareUnoptimized": "黑色(硬體未優化)",
  "Assets.production.models.shellless": "無殼",
  "Assets.production.models.shelllessBroken": "無殼（損壞）",
  "Assets.production.models.silverHeldByLijiaqi": "銀色（李佳奇代持）",

  // ===== LukkeyIssues i18n =====
  "LukkeyIssues.pageTitle": "專案議題追蹤",
  "LukkeyIssues.goToDemo": "前往示範頁",
  "LukkeyIssues.githubProject": "GitHub 專案 ↗",
  "LukkeyIssues.githubManageIssues": "於 GitHub 直接管理 Issues ↗",
  "LukkeyIssues.financeModel": "財務模型",
  "LukkeyIssues.productCoreIssues": "產品核心議題",
  "LukkeyIssues.stats.totalIssues": "📊 議題總數",
  "LukkeyIssues.stats.completed": "✅ 已完成",
  "LukkeyIssues.stats.inProgress": "🔄 進行中",
  "LukkeyIssues.stats.pending": "⏳ 待處理",
  "LukkeyIssues.stats.blocked": "🚫 阻塞",
  "LukkeyIssues.stats.docs": "📚 文件 Docs",
  "LukkeyIssues.tabs.kanban": "看板視圖",
  "LukkeyIssues.tabs.analytics": "數據分析",
  "LukkeyIssues.tabs.market": "市場儀表板",
  "LukkeyIssues.tabs.assets": "資產設備登記表",
  "LukkeyIssues.shareToChatGPT": "使用 ChatGPT 開啟 LUKKEY.json", // ===== PrivacyPolicy i18n =====
  "PrivacyPolicy.title": "LUKKEY 隱私權政策",
  "PrivacyPolicy.intro.p1":
    "在 LUKKEY，我們相信最安全的隱私，是始終掌握在使用者自己手中的隱私。",
  "PrivacyPolicy.intro.p2":
    "因此，無論您使用的是 LUKKEY 硬體冷錢包，或是配套的 LUKKEY 行動應用程式（App），我們始終恪守一條不變的原則：",
  "PrivacyPolicy.intro.p3_strong":
    "除非使用者明確授權，我們不蒐集、不儲存，也不上傳任何使用者資訊。",
  "PrivacyPolicy.intro.p3_tail":
    "所有與使用相關的資料僅儲存在使用者的本機裝置中，絕不會傳輸至 LUKKEY 或任何伺服器。",
  "PrivacyPolicy.intro.p4": "本隱私權政策說明我們如何落實上述原則。",

  "PrivacyPolicy.s1.title": "1. 適用範圍",
  "PrivacyPolicy.s1.appliesTo": "本隱私權政策適用於：",
  "PrivacyPolicy.s1.item.hardware": "LUKKEY 硬體冷錢包",
  "PrivacyPolicy.s1.item.app": "LUKKEY 行動應用程式（App）",
  "PrivacyPolicy.s1.principle":
    "兩者皆遵循「零蒐集、零上傳、僅本機儲存」的統一隱私原則。",

  "PrivacyPolicy.s2.title": "2. 我們不蒐集的資訊",
  "PrivacyPolicy.s2.desc":
    "為保護您的隱私，我們明確承諾不蒐集、不上傳、不儲存任何使用者資訊，包括但不限於：",
  "PrivacyPolicy.s2.li.identity": "身分資訊：姓名、電話、電子郵件、郵寄地址",
  "PrivacyPolicy.s2.li.walletSensitive":
    "錢包敏感資料：私鑰、助記詞、keystore 檔案、錢包密碼",
  "PrivacyPolicy.s2.li.blockchain": "區塊鏈資料：錢包地址、交易紀錄、資產資訊",
  "PrivacyPolicy.s2.li.behavior": "使用行為：App 日誌、點擊紀錄、行為分析",
  "PrivacyPolicy.s2.li.technical": "技術資訊：裝置識別碼、定位資訊、IP 位址",
  "PrivacyPolicy.s2.inShort.title": "總之：",
  "PrivacyPolicy.s2.inShort.desc":
    "您在硬體裝置與 App 中所看到的一切，只存在於您的裝置上；LUKKEY 無從存取。",

  "PrivacyPolicy.s3.title": "3. 硬體冷錢包的隱私與安全設計",
  "PrivacyPolicy.s3.desc":
    "LUKKEY 冷錢包為使用者提供完全離線且安全的操作環境。重點特色包括：",
  "PrivacyPolicy.s3.h1.title": "1. 軍規等級安全硬體",
  "PrivacyPolicy.s3.h1.l1": "EAL6+ 認證的安全晶片（Secure Element）",
  "PrivacyPolicy.s3.h1.l2": "全鏈路硬體層級加密通訊",
  "PrivacyPolicy.s3.h2.title": "2. 安全機制",
  "PrivacyPolicy.s3.h2.l1": "指紋驗證",
  "PrivacyPolicy.s3.h2.l2": "隱私模式",
  "PrivacyPolicy.s3.h2.l3": "多錢包隔離管理",
  "PrivacyPolicy.s3.h3.title": "3. 完全隔離",
  "PrivacyPolicy.s3.h3.l1": "無網路連線",
  "PrivacyPolicy.s3.h3.l2": "無資料線連接",
  "PrivacyPolicy.s3.h4.title": "4. 防拆自毀",
  "PrivacyPolicy.s3.h4.desc":
    "若裝置遭拆解、損壞或發生異常入侵，安全晶片將自動銷毀敏感資料，確保私鑰無法被取出。",
  "PrivacyPolicy.s3.h5.title": "5. 敏感操作僅在安全晶片內執行",
  "PrivacyPolicy.s3.h5.l1": "錢包建立",
  "PrivacyPolicy.s3.h5.l2": "錢包匯入",
  "PrivacyPolicy.s3.h5.l3": "交易簽章",
  "PrivacyPolicy.s3.h5.note":
    "所有敏感流程 100% 在安全晶片內完成，絕不暴露於任何非安全晶片或儲存區域。",
  "PrivacyPolicy.s3.h6.title": "6. 安全晶片以外不儲存敏感資料",
  "PrivacyPolicy.s3.h6.desc":
    "裝置的非安全儲存區域不會存放私鑰、助記詞或任何敏感資訊。",

  "PrivacyPolicy.s4.title": "4. LUKKEY App 的隱私與安全設計",
  "PrivacyPolicy.s4.desc":
    "LUKKEY App 專注於資訊展示與通知，不處理任何錢包敏感資料。",
  "PrivacyPolicy.s4.n1.title": "1. App 不會做的事",
  "PrivacyPolicy.s4.n1.l1": "不產生區塊鏈錢包",
  "PrivacyPolicy.s4.n1.l2": "不匯入區塊鏈錢包",
  "PrivacyPolicy.s4.n1.l3": "不儲存私鑰或助記詞",
  "PrivacyPolicy.s4.n1.l4": "不上傳任何使用者資料",
  "PrivacyPolicy.s4.n1.l5": "不進行行為分析、廣告追蹤或資料蒐集",
  "PrivacyPolicy.s4.n2.title": "2. App 會做的事",
  "PrivacyPolicy.s4.n2.l1": "展示由硬體授權的可公開存取資訊",
  "PrivacyPolicy.s4.n2.l2": "提供隱私設定面板，說明各權限之目的",
  "PrivacyPolicy.s4.n2.l3": "讓使用者可於任何時刻完全控制權限的啟用/停用",
  "PrivacyPolicy.s4.n2.l4": "提供敏感資訊遮罩",
  "PrivacyPolicy.s4.n2.l5": "在特定頁面停用截圖/錄影",
  "PrivacyPolicy.s4.n2.l6": "透過本機比對偵測可疑區塊鏈地址",
  "PrivacyPolicy.s4.n2.l7": "定期更新危險網址、合約與地址清單",
  "PrivacyPolicy.s4.n2.l8": "更新流程為單向：僅由伺服器 → 裝置",
  "PrivacyPolicy.s4.n2.l9": "更新過程不會回傳任何使用者資料",
  "PrivacyPolicy.s4.n3.title": "3. 本機儲存",
  "PrivacyPolicy.s4.n3.p1":
    "App 僅在本機儲存非隱私資料，如 UI 偏好、語言、主題設定。此類資料：",
  "PrivacyPolicy.s4.n3.l1": "不會上傳",
  "PrivacyPolicy.s4.n3.l2": "不會同步",
  "PrivacyPolicy.s4.n3.l3": "LUKKEY 無法存取",

  "PrivacyPolicy.s5.title": "5. 資料傳輸與伺服器政策",
  "PrivacyPolicy.s5.l1": "LUKKEY 伺服器不儲存任何使用者資訊",
  "PrivacyPolicy.s5.l2": "App 與伺服器的通訊僅限於資料庫更新與版本更新",
  "PrivacyPolicy.s5.l3": "通訊過程不傳輸任何使用者資訊",
  "PrivacyPolicy.s5.l4":
    "即使伺服器遭入侵，也不會有使用者資料外洩，因為我們從未取得此類資料",

  "PrivacyPolicy.s6.title": "6. 開源透明",
  "PrivacyPolicy.s6.l1": "LUKKEY App 原始碼已開源",
  "PrivacyPolicy.s6.l2": "LUKKEY 硬體內嵌韌體亦開源",
  "PrivacyPolicy.s6.l3": "在 GitHub 完整公開供任何人稽核",
  "PrivacyPolicy.s6.p": "透明是安全的一部分。",

  "PrivacyPolicy.s7.title": "7. 完整的使用者控制權",
  "PrivacyPolicy.s7.p":
    "即便我們不蒐集使用者資訊，使用者仍對其裝置擁有完整的控制權：",
  "PrivacyPolicy.s7.l1": "您可隨時停用 App 權限",
  "PrivacyPolicy.s7.l2": "您可移除 App 以刪除所有本機 App 資料",
  "PrivacyPolicy.s7.l3": "您可重置硬體裝置以永久清除私鑰與錢包資料",
  "PrivacyPolicy.s7.p2": "LUKKEY 不會、也無法介入上述行為。",

  "PrivacyPolicy.s8.title": "8. 聯絡我們",
  "PrivacyPolicy.s8.p": "若您對本隱私權政策有任何疑問，請聯絡我們：",
  "PrivacyPolicy.s8.email": "電子郵件：info@lukkey.com",
  "PrivacyPolicy.s8.address":
    "地址：LUKKEY 總部，Baarerstrasse 25, 6300 Zug, Switzerland",
  // ===== EmailOtpProtectedRoute i18n =====
  "EmailOtp.checking": "載入中…",
  "EmailOtp.title": "存取受限：請輸入姓名與電子郵件，以取得驗證碼登入",
  "EmailOtp.nameLabel": "姓名",
  "EmailOtp.namePlaceholder": "請輸入姓名",
  "EmailOtp.emailLabel": "電子郵件",
  "EmailOtp.emailPlaceholder": "name@example.com",
  "EmailOtp.sendCode": "發送驗證碼",
  "EmailOtp.resendCode": "重新發送驗證碼",
  "EmailOtp.resendWithCountdown": "重新發送({{s}}s)",
  "EmailOtp.codeValidityHint": "驗證碼有效期約10分鐘",
  "EmailOtp.codeLabel": "電子郵件驗證碼",
  "EmailOtp.codePlaceholder": "輸入收到的驗證碼",
  "EmailOtp.signIn": "登入",
  "EmailOtp.message.codeSent": "驗證碼已發送，請查收郵件",
  "EmailOtp.error.nameRequired": "請輸入姓名",
  "EmailOtp.error.invalidEmail": "請輸入有效的電子郵件地址",
  "EmailOtp.error.sendFailed": "發送驗證碼失敗，請稍後再試",
  "EmailOtp.error.codeRequired": "請輸入驗證碼",
  "EmailOtp.error.verificationFailed": "驗證碼驗證失敗",
  // ===== Academy i18n =====
  "Academy.hero.alert": "安全提醒：警惕釣魚連結，切勿洩露助記詞。",
  "Academy.hero.title1": "LUKKEY",
  "Academy.hero.title2": "學院",
  "Academy.hero.subtitle": "關於加密安全、自我託管與 LUKKEY 冷錢包的實用指南。",
  "Academy.search.placeholder": "搜尋教學、最佳實踐與常見問題…",
  "Academy.search.hint": "[Enter]",
  "Academy.card.type.article": "文章",
  "Academy.list.title": "最新教學",
  "Academy.list.viewAll": "查看全部",
  "Academy.list.empty": "沒有結果，請嘗試其他關鍵詞。",
  "Academy.image.placeholder": "圖片",

  // ===== AcademyArticle i18n =====
  "AcademyArticle.back": "返回學院",
  "AcademyArticle.notFound": "未找到該文章",
  "AcademyArticle.author": "作者",
  "AcademyArticle.unscheduled": "未安排發佈時間",
  "home.hero.reserveCtaLabel": "搶先取得資格 · US$1",
  "home.hero.reserveCtaNote": "可全額退款，無需作出購買承諾。",
};

export default translation;
